import React from "react";

const Home = () => {
  return (
    <>
      <div className="container">
        <div className="justify-content-center">
          <h1>Welcome!</h1>
          <span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque sed
            ullamcorper lectus. Sed bibendum ligula sit amet orci placerat, in
            mollis tellus faucibus. Donec elementum mauris purus, et posuere
            arcu accumsan eget. Phasellus dignissim nec erat sit amet pharetra.
            Integer lectus elit, blandit quis tempor ut, commodo non nibh.
            Suspendisse gravida vehicula mi, et malesuada risus. Integer
            eleifend a leo at vulputate. Pellentesque venenatis lectus vel nibh
            accumsan, blandit vestibulum urna egestas. Morbi eros urna, mattis
            imperdiet tincidunt in, venenatis at sem. Praesent interdum egestas
            euismod. Vestibulum quis ullamcorper mauris, quis condimentum augue.
            <br /> <br />
            Morbi id magna ut libero pharetra facilisis. Lorem ipsum dolor sit
            amet, consectetur adipiscing elit. Vivamus posuere quis elit vitae
            aliquet. Nam malesuada sodales nisi, non fringilla urna molestie in.
            Suspendisse et sapien id mauris bibendum iaculis pharetra sit amet
            ligula. Aenean vel nibh id sapien hendrerit pulvinar. Duis lacus
            nisi, laoreet et dui eget, commodo porta risus. Praesent ullamcorper
            vitae sem et aliquam. Maecenas pharetra libero diam, a vulputate
            lacus accumsan id. Mauris ut interdum leo, et convallis sem.
            Pellentesque habitant morbi tristique senectus et netus et malesuada
            fames ac turpis egestas. Interdum et malesuada fames ac ante ipsum
            primis in faucibus.
            <br /> <br />
            Sed dignissim neque sagittis nisl cursus ornare. Nullam hendrerit
            libero at velit condimentum rhoncus. Morbi at gravida metus. Duis
            ipsum sem, euismod eget aliquam eget, iaculis sit amet justo. Sed
            sodales, lectus quis efficitur varius, libero orci maximus enim, a
            finibus nibh magna id ligula. Etiam at consectetur tortor. In
            pellentesque pulvinar dignissim. Quisque bibendum nunc libero,
            eleifend molestie felis elementum non. Orci varius natoque penatibus
            et magnis dis parturient montes, nascetur ridiculus mus. Vivamus sit
            amet quam dolor. Nam ac magna tincidunt, malesuada lectus vel,
            luctus libero.
          </span>
        </div>
      </div>
    </>
  );
};

export default Home;
